import PropTypes from "prop-types";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useLoader } from "@/hooks/LoaderProvider";
import { deleteTownHall } from "@/store/redux/slices/townhall/townhall_slice";
import Delete from "@/components/common/alerts/Delete";
import Button from "@/components/common/Button";

const ActionButtons = ({ townHall, onDeleteSuccess }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showLoader, hideLoader } = useLoader();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleModifyClick = () => {
    navigate(`/dashboard/townhall/edit/${townHall._id}`);
  };

  const handleDeleteClick = () => {
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    try {
      setShowDeleteModal(false);
      showLoader();
      await dispatch(deleteTownHall(townHall._id)).unwrap();
      hideLoader();
      onDeleteSuccess();
    } catch (error) {
      console.error("Failed to delete townhall:", error);
      hideLoader();
    }
  };

  return (
    <>
      <div className="flex gap-4">
        <Button
          text="DELETE"
          onClick={handleDeleteClick}
          customBgColor="white"
          customTextColor="primary"
          className="h-[34px] flex-1 border border-primary hover:bg-white"
        />
        <Button
          text="MODIFY"
          onClick={handleModifyClick}
          className="h-[34px] flex-1"
          customBgColor="primary"
          customTextColor="white"
          isActive={true}
          color="primary"
        />
      </div>

      {/* Delete Modal */}
      <Delete
        isVisible={showDeleteModal}
        onProceed={handleConfirmDelete}
        header="Delete Town Hall"
        paragraph="Are you sure you want to delete this town hall? This action cannot be undone."
        proceedButtonText="Delete"
        cancelButtonText="Cancel"
        onClose={() => setShowDeleteModal(false)}
      />
    </>
  );
};

ActionButtons.propTypes = {
  townHall: PropTypes.shape({
    _id: PropTypes.string,
  }),
  onDeleteSuccess: PropTypes.func,
};

export default ActionButtons;
